export default __webpack_public_path__ + "search-examples-list-based-search-thumbnail-960-ca882bf42d05921b46a94937f569a575.png";